module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_points-1c5477e25c18f35ca8452698f54773cf.svg";